import { render, staticRenderFns } from "./PrefixManagement.vue?vue&type=template&id=6aeade28&"
import script from "./PrefixManagement.vue?vue&type=script&lang=js&"
export * from "./PrefixManagement.vue?vue&type=script&lang=js&"
import style0 from "./PrefixManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports